import type { EvidenceReport } from '../../lib/evidenceReport';

type Level = NonNullable<EvidenceReport['confidenceLevel']>;

// Deliberately not the quiet, colorless Badge primitive (components/ui/
// Badge.tsx) - confidence is exactly the kind of thing this codebase's
// design system reserves color for: a glanceable severity signal, not row
// metadata. Low uses the same neutral treatment as Badge itself (Low
// confidence isn't an error state, just honest uncertainty - see
// buildMultiPrompt's "grounded uncertainty is more useful than false
// confidence").
const LEVEL_STYLE: Record<Level, string> = {
  High: 'border-emerald-500/30 bg-emerald-500/10 text-emerald-700 dark:text-emerald-400',
  Medium: 'border-amber-500/30 bg-amber-500/10 text-amber-700 dark:text-amber-400',
  Low: 'border-black/15 dark:border-white/20 bg-black/[0.03] dark:bg-white/[0.05] text-black/60 dark:text-white/60',
};

export function ConfidenceBadge({ level }: { level: Level }) {
  return (
    <span
      className={`inline-flex items-center rounded-full border px-2 py-0.5 text-[11px] font-semibold leading-none whitespace-nowrap ${LEVEL_STYLE[level]}`}
    >
      {level} confidence
    </span>
  );
}
